import { tabAccessControl } from "../../../_helpers/access-control";

let FinanceTabs = [
  {
    text: "All",
    path: `/journals`,
    applicationFeatureCode: "Journals",
  },
  // {
  //   text: "All",
  //   path: `/gl-account`,
  //   applicationFeatureCode: "Journals",
  // },
];


 function GetIndexByTabName(tabName){
  return tabAccessControl(FinanceTabs).findIndex((x) => x.text == tabName);
}
 
export { FinanceTabs, GetIndexByTabName };